import { Button, Col, Form, Input, Row, Select, Tag } from "antd";
import { DetalhesFiltrosModel } from "../../models/detalhesFiltrosModel";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import { adicionarFiltro, adicionarFiltroFormatado, removerFiltro, removerFiltroFormatado } from "../../redux/slices/configuracoes/configuracoesSlice";
import { CloseCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { PessoaModel } from "../../models/pessoa/pessoaModel";
import { Vm_ContaBancoModel } from "../../models/contaBanco/vm_contaBancoModel";
import { buscarPessoa } from "../../services/pessoaService";
import { buscarFormaPagamentoRecebimento } from "../../services/formaPagamentoRecebimentoService";
import { buscarContaBanco } from "../../services/contaBancoService";
import { setBuscaLancamentoBancario } from "../../redux/slices/lancamentoBancario/lancamentoBancarioSlice";
import { buscarLancamentoBancario } from "../../services/lancamentoBancarioService";
import dayjs from "dayjs";
import { listarSorteio } from "../../services/sorteioService";
import { currencyBRL, realParaNumber } from "../../util/dinheiroBRAuxiliar";
import { NumericFormat } from "react-number-format";
import { buscarAuditoriaContaFinanceira } from "../../services/auditoriaContaFinanceiraService";
import { setBuscaContaFinanceira } from "../../redux/slices/contaFinanceira/contaFinanceiraSlice";
import { buscarContaFinanceira } from "../../services/contaFinanceiraService";
import { setBuscaRelatorioContaBancaria } from "../../redux/slices/relatorio/relatorioSlice";
import { buscarRelatorioLancamentoFinanceiro, gerarRelatorioContaBancaria } from "../../services/relatorioService";
import { setBuscaAuditoriaContaFinanceira } from "../../redux/slices/auditoriaContaFinanceira/auditoriaContaFinanceiraSlice";
import { buscarPlanoContaFinanceiro } from "../../services/planoContaFinanceiroService";
import SelectTree from "../inputs/selectTree";
import { EmpresaModel } from "../../models/empresa/empresaModel";

interface FormFiltrosValues {
  campo: string;
  operador: string;
  valor: { key: string; value: number; label: string };
  valor1: string;
  valor2: string;
}

type FiltroComponentProps = {
  origem: string;
  idEmpresa: number | null;
};

const FiltroComponent = ({ origem, idEmpresa }: FiltroComponentProps) => {
  //estados globais
  const configuracoesState = useAppSelector((state) => state.configuracoes);
  const pessoaState = useAppSelector((state) => state.pessoa);
  const planoContaFinanceiroState = useAppSelector((state) => state.planoContaFinanceiro);
  const contaBancoState = useAppSelector((state) => state.contaBanco);
  const formaPagamentoRecebimentoState = useAppSelector((state) => state.formaPagamentoRecebimento);
  const lancamentoBancarioState = useAppSelector((state) => state.lancamentoBancario);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const empresaState = useAppSelector((state) => state.empresa);
  const auditoriaContaFinanceiraState = useAppSelector((state) => state.auditoriaContaFinanceira);
  const contaFinanceiraState = useAppSelector((state) => state.contaFinanceira);
  const relatorioState = useAppSelector((state) => state.relatorio);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<FormFiltrosValues>();
  const [campoFormatado, setCampoFormatado] = useState<string>("");
  const [operadorFormatado, setOperadorFormatado] = useState<string>("");
  const [operadorEntre, setOperadorEntre] = useState<boolean>(false);

  //lista de operadores
  let operadoresInicial = [
    {
      value: "Igual",
      label: "Igual",
    },
    {
      value: "Diferente",
      label: "Diferente",
    },
    // {
    //   value: "Entre",
    //   label: "Entre",
    // },
    // {
    //   value: "Maior",
    //   label: "Maior",
    // },
    // {
    //   value: "Maior ou igual",
    //   label: "Maior ou igual",
    // },
    // {
    //   value: "Menor",
    //   label: "Menor",
    // },
    // {
    //   value: "Menor ou igual",
    //   label: "Menor ou igual",
    // },
    {
      value: "Começa com",
      label: "Começa com",
    },
    {
      value: "Termina com",
      label: "Termina com",
    },
    {
      value: "Possui texto",
      label: "Possui texto",
    },
  ];

  const [operadores, setOperadores] = useState<any[]>(operadoresInicial);

  useEffect(() => {
    form.resetFields(["operador", "valor", "valor2"]);

    if (pessoaState.list.length === 0) dispatch(buscarPessoa(pessoaState.busca));
    if (formaPagamentoRecebimentoState.list.length === 0) dispatch(buscarFormaPagamentoRecebimento(formaPagamentoRecebimentoState.busca));

    const searchEmpresaSorteios = empresaState.list.filter((empresa: EmpresaModel) => empresa.idEmpresaMarketing === idEmpresa);
    var listIdEmpresas = searchEmpresaSorteios.length !== 0 ? searchEmpresaSorteios[0].id + "," + idEmpresa : idEmpresa?.toString();
    dispatch(listarSorteio(listIdEmpresas ?? null));

    var empresa = empresaState.list.find((empresa: EmpresaModel) => empresa.id === idEmpresa);
    dispatch(buscarPlanoContaFinanceiro({ ...planoContaFinanceiroState.busca, idGrupoPlanoContaFinanceiro: empresa?.idGrupoPlanoContaFinanceiro ?? null, receitaDespesa: null }));
  }, [idEmpresa]);

  const onChangeCampo = async (campo: string) => {
    form.resetFields(["operador", "valor", "valor2"]);
    switch (campo) {
      case "Cliente / Fornecedor":
        setCampoFormatado("ClienteFornecedor");
        setOperadores([
          {
            value: "Igual",
            label: "Igual",
          },
          {
            value: "Diferente",
            label: "Diferente",
          },
        ]);
        break;
      case "Plano de conta financeiro":
        setCampoFormatado("PlanoContaFinanceiro");
        setOperadores([
          {
            value: "Igual",
            label: "Igual",
          },
          {
            value: "Diferente",
            label: "Diferente",
          },
        ]);
        break;
      case "Conta bancária":
        setCampoFormatado("ContaBanco");
        setOperadores([
          {
            value: "Igual",
            label: "Igual",
          },
          {
            value: "Diferente",
            label: "Diferente",
          },
        ]);
        break;
      case "Forma de pagamento":
        setCampoFormatado("FormaPagamentoRecebimento");
        setOperadores([
          {
            value: "Igual",
            label: "Igual",
          },
          {
            value: "Diferente",
            label: "Diferente",
          },
        ]);
        break;
      case "Histórico":
        setCampoFormatado("Historico");
        setOperadores(operadoresInicial);
        break;
      case "Número do documento":
        setCampoFormatado("NumeroDocumento");
        setOperadores(operadoresInicial);
        break;
      case "Tipo de lançamento (Entrada / saída)":
        setCampoFormatado("TipoLancamento");
        setOperadores([
          {
            value: "Igual",
            label: "Igual",
          },
        ]);
        break;
      case "Sorteio":
        setCampoFormatado("Sorteio");
        setOperadores([
          {
            value: "Igual",
            label: "Igual",
          },
          {
            value: "Diferente",
            label: "Diferente",
          },
        ]);
        break;
      case "Valor":
        setCampoFormatado("Valor");
        let camposValores = [
          {
            value: "Igual",
            label: "Igual",
          },
          {
            value: "Diferente",
            label: "Diferente",
          },
          {
            value: "Entre",
            label: "Entre",
          },
          {
            value: "Menor",
            label: "Menor",
          },
          {
            value: "Maior",
            label: "Maior",
          },
        ];
        setOperadores(camposValores);
        break;
      default:
        break;
    }
  };

  const onChangeOperador = (operador: string) => {
    switch (operador) {
      case "Igual":
        setOperadorFormatado("EQ");
        setOperadorEntre(false);
        break;
      case "Diferente":
        setOperadorFormatado("DF");
        setOperadorEntre(false);
        break;
      case "Entre":
        setOperadorFormatado("BT");
        setOperadorEntre(true);
        break;
      case "Maior":
        setOperadorFormatado("MT");
        setOperadorEntre(false);
        break;
      case "Menor":
        setOperadorFormatado("LT");
        setOperadorEntre(false);
        break;
      case "Começa com":
        setOperadorFormatado("SW");
        setOperadorEntre(false);
        break;
      case "Termina com":
        setOperadorFormatado("EW");
        setOperadorEntre(false);
        break;
      case "Possui texto":
        setOperadorFormatado("CT");
        setOperadorEntre(false);
        break;
      default:
        break;
    }
  };

  const submit = (values: FormFiltrosValues) => {
    var filtros: DetalhesFiltrosModel = {
      campo: values.campo,
      operador: values.operador,
      valor: campoFormatado === "Valor" || campoFormatado === "NumeroDocumento" || campoFormatado === "Historico" ? values.valor1 : values.valor.label,
      valor2: values.valor2,
    };
    var filtrosFormatado: DetalhesFiltrosModel = {
      campo: campoFormatado,
      operador: operadorFormatado,
      valor: campoFormatado === "Valor" || campoFormatado === "NumeroDocumento" || campoFormatado === "Historico" ? values.valor1.toString() : values.valor?.value?.toString(),
      valor2: values.valor2,
    };

    dispatch(adicionarFiltro(filtros));
    dispatch(adicionarFiltroFormatado(filtrosFormatado));

    if (origem === "lancamentoBancario") {
      var buscaLancamentoBancario = { ...lancamentoBancarioState.busca, filtros: [...configuracoesState.filtrosFormatado, filtrosFormatado] };
      dispatch(setBuscaLancamentoBancario(buscaLancamentoBancario));
      dispatch(buscarLancamentoBancario(buscaLancamentoBancario));
    }
    if (origem === "auditoria") {
      var buscaAuditoriaContaFinanceira = { ...auditoriaContaFinanceiraState.busca, filtros: [...configuracoesState.filtrosFormatado, filtrosFormatado] };
      dispatch(setBuscaAuditoriaContaFinanceira(buscaAuditoriaContaFinanceira));
      dispatch(buscarAuditoriaContaFinanceira(buscaAuditoriaContaFinanceira));
    }
    if (origem === "contaFinanceiraD" || origem === "contaFinanceiraR") {
      var buscaContaFinanceira = { ...contaFinanceiraState.busca, filtros: [...configuracoesState.filtrosFormatado, filtrosFormatado] };
      dispatch(setBuscaContaFinanceira(buscaContaFinanceira));
      dispatch(buscarContaFinanceira(buscaContaFinanceira));
    }
    if (origem === "relatorioLancamentoBancario") {
      dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: relatorioState.buscaContaBancaria.idEmpresa }));
      var buscaRelatorioLancamentoBancario = { ...relatorioState.buscaContaBancaria, filtros: [...configuracoesState.filtrosFormatado, filtrosFormatado] };
      dispatch(setBuscaRelatorioContaBancaria(buscaRelatorioLancamentoBancario));
      dispatch(gerarRelatorioContaBancaria(buscaRelatorioLancamentoBancario));
    }
    if (origem === "relatorioLancamentoPlanoConta") {
      dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: relatorioState.buscaLancamentoFinanceiro.idEmpresa }));
      var buscaRelatorioLancamentoPlanoConta = { ...relatorioState.buscaLancamentoFinanceiro, filtros: [...configuracoesState.filtrosFormatado, filtrosFormatado] };
      dispatch(setBuscaRelatorioContaBancaria(buscaRelatorioLancamentoPlanoConta));
      dispatch(buscarRelatorioLancamentoFinanceiro(buscaRelatorioLancamentoPlanoConta));
    }

    form.resetFields();
  };

  const excluirFiltro = (index: number) => {
    dispatch(removerFiltro(index));
    dispatch(removerFiltroFormatado(index));

    const updatedFiltrosFormatado = configuracoesState.filtrosFormatado.filter((_, i) => i !== index);

    if (origem === "lancamentoBancario") {
      var buscaLancamentoBancario = { ...lancamentoBancarioState.busca, filtros: updatedFiltrosFormatado };
      dispatch(setBuscaLancamentoBancario(buscaLancamentoBancario));
      dispatch(buscarLancamentoBancario(buscaLancamentoBancario));
    }
    if (origem === "auditoria") {
      var buscaAuditoriaContaFinanceira = { ...auditoriaContaFinanceiraState.busca, filtros: updatedFiltrosFormatado };
      dispatch(setBuscaAuditoriaContaFinanceira(buscaAuditoriaContaFinanceira));
      dispatch(buscarAuditoriaContaFinanceira(buscaAuditoriaContaFinanceira));
    }
    if (origem === "contaFinanceiraD" || origem === "contaFinanceiraR") {
      var buscaContaFinanceira = { ...contaFinanceiraState.busca, filtros: updatedFiltrosFormatado };
      dispatch(setBuscaContaFinanceira(buscaContaFinanceira));
      dispatch(buscarContaFinanceira(buscaContaFinanceira));
    }
    if (origem === "relatorioLancamentoBancario") {
      dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: relatorioState.buscaContaBancaria.idEmpresa }));
      var buscaRelatorioLancamentoBancario = { ...relatorioState.buscaContaBancaria, filtros: updatedFiltrosFormatado };
      dispatch(setBuscaRelatorioContaBancaria(buscaRelatorioLancamentoBancario));
      dispatch(gerarRelatorioContaBancaria(buscaRelatorioLancamentoBancario));
    }
    if (origem === "relatorioLancamentoPlanoConta") {
      dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: relatorioState.buscaLancamentoFinanceiro.idEmpresa }));
      var buscaRelatorioLancamentoPlanoConta = { ...relatorioState.buscaLancamentoFinanceiro, filtros: updatedFiltrosFormatado };
      dispatch(setBuscaRelatorioContaBancaria(buscaRelatorioLancamentoPlanoConta));
      dispatch(buscarRelatorioLancamentoFinanceiro(buscaRelatorioLancamentoPlanoConta));
    }
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "14px", marginTop: "6px" }}>
        {configuracoesState.filtros.map((a: DetalhesFiltrosModel, index) => {
          return (
            <div key={index}>
              {a.operador === "Entre" ? (
                <>
                  {index + 1 + ". " + a.campo} <Tag style={{ marginInlineEnd: 0 }}>{a.operador}</Tag> {currencyBRL(a.valor)} e {currencyBRL(a.valor2)}
                  <CloseCircleOutlined style={{ color: "red", marginLeft: "3px" }} onClick={() => excluirFiltro(index)} />
                </>
              ) : (
                <>
                  {index + 1 + ". " + a.campo} <Tag style={{ marginInlineEnd: 0 }}>{a.operador}</Tag> {a.campo === "Valor" ? currencyBRL(a.valor) : a.valor}{" "}
                  <CloseCircleOutlined style={{ color: "red", marginLeft: "3px" }} onClick={() => excluirFiltro(index)} />
                </>
              )}
            </div>
          );
        })}
      </div>
      <Row>
        <Col span={16}>
          <Form form={form} onFinish={submit}>
            <Row gutter={8}>
              <Col span={6}>
                <Form.Item
                  name="campo"
                  rules={[
                    {
                      required: true,
                      message: "Selecione uma opção para adicionar ao filtro",
                    },
                  ]}
                >
                  <Select
                    optionFilterProp="label"
                    style={{ width: "100%" }}
                    onChange={onChangeCampo}
                    options={
                      origem === "lancamentoBancario" || origem === "relatorioLancamentoBancario" || origem === "relatorioLancamentoPlanoConta"
                        ? [
                            {
                              value: "Cliente / Fornecedor",
                              label: "Cliente / Fornecedor",
                            },
                            {
                              value: "Plano de conta financeiro",
                              label: "Plano de conta financeiro",
                            },
                            {
                              value: "Conta bancária",
                              label: "Conta bancária",
                            },
                            {
                              value: "Forma de pagamento",
                              label: "Forma de pagamento",
                            },
                            {
                              value: "Histórico",
                              label: "Histórico",
                            },
                            {
                              value: "Número do documento",
                              label: "Número do documento",
                            },
                            {
                              value: "Valor",
                              label: "Valor",
                            },
                            {
                              value: "Tipo de lançamento (Entrada / saída)",
                              label: "Tipo de lançamento (Entrada / saída)",
                            },
                          ]
                        : [
                            {
                              value: "Cliente / Fornecedor",
                              label: "Cliente / Fornecedor",
                            },
                            {
                              value: "Plano de conta financeiro",
                              label: "Plano de conta financeiro",
                            },
                            {
                              value: "Conta bancária",
                              label: "Conta bancária",
                            },
                            {
                              value: "Forma de pagamento",
                              label: "Forma de pagamento",
                            },
                            {
                              value: "Histórico",
                              label: "Histórico",
                            },
                            { value: "Sorteio", label: "Sorteio" },
                            {
                              value: "Número do documento",
                              label: "Número do documento",
                            },
                            {
                              value: "Valor",
                              label: "Valor",
                            },
                            {
                              value: "Tipo de lançamento (Entrada / saída)",
                              label: "Tipo de lançamento (Entrada / saída)",
                            },
                          ]
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item
                  name="operador"
                  rules={[
                    {
                      required: true,
                      message: "Selecione uma opção para adicionar ao filtro",
                    },
                  ]}
                >
                  <Select optionFilterProp="label" style={{ width: "100%" }} onChange={onChangeOperador} options={operadores} />
                </Form.Item>
              </Col>
              {campoFormatado === "" ? (
                <></>
              ) : (
                <Col span={operadorEntre ? 4 : 11}>
                  <Form.Item name={campoFormatado === "Valor" || campoFormatado === "NumeroDocumento" || campoFormatado === "Historico" ? "valor1" : "valor"}>
                    {campoFormatado === "ClienteFornecedor" ? (
                      <Select
                        optionFilterProp="label"
                        style={{ width: "100%" }}
                        loading={pessoaState.loading}
                        showSearch
                        labelInValue
                        filterOption={(input, option) => option?.filterLabel.toLowerCase().includes(input.toLowerCase()) === true}
                        options={pessoaState.list.map((a: PessoaModel) => {
                          const label = a.apelido === a.razaoSocial ? "" : " (" + a.apelido + ")";
                          return {
                            value: a.id,
                            label: a.razaoSocial + label,
                            filterLabel: a.razaoSocial + a.apelido,
                            disabled: !a.ativo,
                          };
                        })}
                      />
                    ) : campoFormatado === "PlanoContaFinanceiro" ? (
                      <SelectTree loading={planoContaFinanceiroState.loading} list={planoContaFinanceiroState.list} props={{ labelInValue: true }} />
                    ) : campoFormatado === "ContaBanco" ? (
                      <Select
                        showSearch
                        optionFilterProp="label"
                        placeholder="Selecione a conta banco"
                        labelInValue
                        filterOption={(input, option) => option?.label.toLowerCase().includes(input.toLowerCase()) === true}
                        loading={contaBancoState.loading}
                        options={contaBancoState.list.map((a: Vm_ContaBancoModel) => ({
                          value: a.id,
                          label: a.denominacaoPersonalizada,
                          disabled: !a.ativo,
                        }))}
                      />
                    ) : campoFormatado === "FormaPagamentoRecebimento" ? (
                      <Select
                        showSearch
                        optionFilterProp="label"
                        style={{ width: "100%" }}
                        labelInValue
                        filterOption={(input, option) => option?.label.toLowerCase().includes(input.toLowerCase()) === true}
                        loading={formaPagamentoRecebimentoState.loading}
                        options={formaPagamentoRecebimentoState.list.map((a: any) => ({
                          value: a.id,
                          label: a.denominacao,
                          ativo: !a.ativo,
                        }))}
                      />
                    ) : campoFormatado === "Historico" ? (
                      <Input type="text" />
                    ) : campoFormatado === "Sorteio" ? (
                      <Select
                        showSearch
                        optionFilterProp="label"
                        style={{ width: "100%" }}
                        loading={sorteioState.loadingEmpresas}
                        labelInValue
                        filterOption={(input, option) => option?.label.toLowerCase().includes(input.toLowerCase()) === true}
                        options={sorteioState.listSorteioEmpresas.map((a: any) => ({
                          value: a.idSorteio,
                          label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                        }))}
                      />
                    ) : campoFormatado === "NumeroDocumento" ? (
                      <Input type="text" />
                    ) : campoFormatado === "Valor" ? (
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        style={{ width: "100%" }}
                        prefix="R$"
                        fixedDecimalScale={true}
                        onChange={() => form.setFieldValue("valor1", realParaNumber(form.getFieldValue("valor1")))}
                      />
                    ) : (
                      <Select
                        labelInValue
                        style={{ width: "100%" }}
                        options={[
                          {
                            value: "E",
                            label: "Entrada",
                          },
                          {
                            value: "S",
                            label: "Saída",
                          },
                        ]}
                      />
                    )}
                  </Form.Item>
                </Col>
              )}
              {operadorEntre ? (
                <Col span={4}>
                  <Form.Item
                    name="valor2"
                    rules={[
                      {
                        required: true,
                        message: "Selecione uma opção para adicionar ao filtro",
                      },
                    ]}
                  >
                    <NumericFormat
                      className="ant-input noBoderColor number-input"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      style={{ width: "100%" }}
                      prefix="R$"
                      fixedDecimalScale={true}
                      onChange={() => form.setFieldValue("valor2", realParaNumber(form.getFieldValue("valor2")))}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <></>
              )}
              <Col span={4}>
                <Form.Item>
                  <Button className="botaoAdicionar" type="primary" htmlType="submit">
                    <PlusCircleOutlined /> Adicionar
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default FiltroComponent;
